import React from "react";
import PropTypes from "prop-types";

import Icon from "components/Library/Icon";
import styles from "./CopyConfirmationTooltip.css";

export default function CopyConfirmationTooltip({ open }) {
  // in order for screenreaders to correctly interpret an aria-live region,
  // it needs to be present on the page before text is inserted
  return (
    <div aria-live="polite">
      {
        open &&
        <div className={styles.root}>
          <Icon name="clipboard"
            path="icons"
            description="Copied"
            className={styles.icon} />
          <span>Link copied to clipboard</span>
        </div>
      }
    </div>
  );
}

CopyConfirmationTooltip.propTypes = {
  open: PropTypes.bool.isRequired,
};
